import "./src/license";
import { URLUtil } from "@luciad/ria-sample-common/URLUtil";
import "./main.css";
import "./src/init.js";
import { ContentManager } from "./src/ContentManager";
import { addBottomBar, addControls, addSwipeController, validateSelectedCity, validateShareViewParams } from "./src/UiUtil";
import { WebGLMap } from "@luciad/ria/view/WebGLMap";
import { GEOCENTRIC } from "./src/Reference";
import { SimpleBalloonContentProvider } from "@luciad/ria-sample-common/balloon/SimpleBalloonContentProvider";
import { toast } from "@luciad/ria-sample-common/toast";
import { ReferenceType } from "@luciad/ria/reference/ReferenceType";
import { getReference } from "@luciad/ria/reference/ReferenceProvider";
import { LayerType } from "@luciad/ria/view/LayerType";
import { LayerTreeVisitor } from "@luciad/ria/view/LayerTreeVisitor";
import { LayerTreeNode } from "@luciad/ria/view/LayerTreeNode";
import { WMSCapabilities } from "@luciad/ria/model/capabilities/WMSCapabilities";
import { WMTSCapabilities } from "@luciad/ria/model/capabilities/WMTSCapabilities";
import { WMSDataLoader } from "./src/OGCservices/WMSDataLoader";
import { WMTSDataLoader } from "./src/OGCservices/WMTSDataLoader";
import { FeatureLayer } from "@luciad/ria/view/feature/FeatureLayer";
import { getFitBounds } from "@luciad/ria-sample-common/FitBoundsUtil";
import { checkSafariAndReload } from "./src/BrowserUtil";
import { ShareView, createCameraView, getCameraParamsFromURL, getShortUrl} from "./src/sharepanel/ShareView"

checkSafariAndReload();

const map = new WebGLMap("map", { reference: GEOCENTRIC });
map.effects.antiAliasing = true; // Enable anti-aliasing for smoother 3D tiles

const contentManager = new ContentManager(map);

addControls(map);

addSwipeController(map);

addBottomBar(contentManager);

validateSelectedCity().then(citySelected => {
  if (citySelected) {

    // Validate params for map view from url
    validateShareViewParams().then(viewParams => {
      if (viewParams) {
        // Create camera view from params provided in url
        let viewParamsFromURL = getCameraParamsFromURL();
        createCameraView(map, viewParamsFromURL, { animate: true });

        // Display data of the city (cs: obec) - activate layer
        contentManager.setActiveSource(URLUtil.queryParameters.obec, { animate: false, navigate: false })
      }

      // Otherwise zoom to the city
      else {
        contentManager.setActiveSource(URLUtil.queryParameters.obec, { animate: true, navigate: true});
      }
    });
  }
}); 

// OGC services
// a promise to track asynchronous actions in the current step
var currentStepPromise;

var app = {
  nodes: {
    overlay: document.getElementById("overlay"),
    nextstep: document.getElementsByClassName("nextstep"),
    previousstep: document.getElementsByClassName("previousstep"),
    datatoggles: document.querySelectorAll("[data-toggles]"),
    wms: {
      add: document.getElementById("wmsadd"),
      load: document.getElementById("wmsload"),
      url: document.getElementById("wmsurl"),
      layersPanel: document.getElementById("wmslayerspanel")
    },
    wmts: {
      add: document.getElementById("wmtsadd"),
      load: document.getElementById("wmtsload"),
      url: document.getElementById("wmtsurl"),
      layersPanel: document.getElementById("wmtslayerspanel"),
      style: document.getElementById("wmts-style")
    },
    show: {
      connect: document.getElementById("addconnect")
    },
    component: {
      connect: document.getElementById("addconnectui"),
      wms: document.getElementById("addwmsui"),
      wmts: document.getElementById("addwmtsui")
    }
  },
  handlers: {
    connect: function() {
    },
    addoverlay: function(v) {
      Object.keys(app.nodes.show).forEach(function(key) {
        app.nodes.overlay.classList.add("visible");
        if (v !== key) {
          app.nodes.component[key].classList.add("hidden");
          app.nodes.show[key].classList.remove("active");
        } else {
          app.nodes.component[key].classList.remove("hidden");
          app.nodes.show[key].classList.add("active");
          var steps = selectDescendantBySelector(app.nodes.component[key], ".step");
          Object.keys(steps).forEach(function(key) {
            steps[key].classList.toggle("hidden", key !== "0");
          });
        }
      });
    },
    removeoverlay: function() {
      app.nodes.overlay.classList.remove("visible");
      Object.keys(app.nodes.show).forEach(function(key) {
        app.nodes.show[key].classList.remove("active");
      });
    },
    nextstep: function(e) {
      var target = e.target;
      var proceed = function() {
        getNextStep(findClosestAncestor(target, ".step"), target.getAttribute("data-path"));
      };
      if (currentStepPromise) {
        currentStepPromise.then(function() {
          proceed();
        }).catch(function() {}).then(function() {
          currentStepPromise = null;
        });
      } else {
        proceed();
      }
    },
    previousstep: function(e) {
      var target = e.target;
      var stepNode = findClosestAncestor(target, ".step");
      var previousStepNode = getPreviousSibling(stepNode, ".step");
      if (previousStepNode) {
        clearOnLoad(previousStepNode);
        stepNode.classList.add("hidden");
        previousStepNode.classList.remove("hidden");
      }
    },
    wms: {
      show: function( /*e*/) {
        app.state.wms = {
          layers: []
        };
      },
      load: function() {
        var url = app.nodes.wms.url.value.split("?")[0].trim() + "?";
        currentStepPromise = WMSCapabilities.fromURL(url)
          .then(function(capabilities) {
            app.state.wms.capabilities = capabilities;
            app.state.wms.layers = flattenWmsLayerHierarchy(capabilities.layers)
              .filter(function(l) {
                return typeof l.name === "string";
              })
              .map(function(l) {
                return {
                  layer: l,
                  name: l.name,
                  title: l.title,
                  isSelected: false,
                  selectedStyle: "",
                  styles: l.styles.map(function(s) {
                    return {
                      name: s.name,
                      title: s.title
                    };
                  })
                };
              });

            renderWMSLayersPanel();
          }).catch(function(err) {
            toast.error(null, "Error loading " + url + ":<br>" + err.message, err);
            // rethrow err so the promise is not resolved successfully
            throw err;
          });
      },
      add: function( /*e*/) {
        // use the maps reference as preferred WMS model reference in case of a geodetic or projected reference
        // request WebMercator otherwise
        var mapRefType = map.reference.referenceType;
        var preferredWMSModelReference =
          (mapRefType === ReferenceType.GEODETIC || mapRefType === ReferenceType.CARTESIAN) ? map.reference
            : getReference("EPSG:3857");

        addLayer(
          WMSDataLoader.createLayer(
            app.state.wms.capabilities,
            app.state.wms.layers,
            preferredWMSModelReference,
            true), true);
      }
    },
    wmts: {
      show: function(e) {
        app.state.wmts = {
          layer: {},
          style: {},
          layers: [],
          capabilities: {}
        };
      },
      add: function(e) {
        var selectedLayer = app.state.wmts.layers.filter(function(l) {
          return l.identifier === app.state.wmts.selectedLayer;
        })[0];
        var selectedLayerName = selectedLayer && selectedLayer.title;
        var selectedLayerIdentifier = selectedLayer && selectedLayer.identifier;
        var capabilities = app.state.wmts.capabilities;

        var layerConfig = {
          layer: selectedLayerIdentifier,
          style: app.state.wmts.style
        };
        // in case of a non-WebGL view, we supply the map reference as desired WMTS tile matrix reference,
        // because this view type does not support raster reprojection
        try {
          var layer = WMTSDataLoader.createLayerFromCapabilities(capabilities, selectedLayerName, layerConfig, {
            reference: getReference("EPSG:3857")
          });

          addLayer(layer, true);
        } catch (error) {
          toast.error(null, "Nepodařilo se přidat vrstvu: " + error.message, error);
        }
      },
      load: function(e) {
        var url = app.nodes.wmts.url.value.trim();
        url = url + (url.indexOf("?") >= 0 ? "&" : "?") + "REQUEST=GetCapabilities&SERVICE=WMTS";
        currentStepPromise = WMTSCapabilities.fromURL(url)
          .then(function(capabilities) {
            app.state.wmts.capabilities = capabilities;
            app.state.wmts.layers = capabilities.layers
              .filter(function(l) {
                return typeof l.title === "string";
              })
              .map(function(l) {
                return {
                  layer: l,
                  identifier: l.identifier,
                  title: l.title,
                  isSelected: false,
                };
              });

            renderWMTSLayersPanel();
          }).catch(function(err) {
            toast.error(null, "Error loading " + url + ":<br>" + err.message, err);
            // rethrow err so the promise is not resolved successfully
            throw err;
          });
      },
    },
    show: function(v, e) {
      if (!v || app.nodes.show[v].classList.contains("active")) {
        /* Toggle off component*/
        app.handlers.removeoverlay();
      } else {
        /* Toggle on component*/
        app.handlers[v].show && app.handlers[v].show(e);
        app.handlers.addoverlay(v);
      }
      resetMapSize();
    }
  },
  state: {
    wms: {},
    wmts: {}
  }
};

document.body.addEventListener("click", function(e) {
  if (Array.prototype.indexOf.call(app.nodes.nextstep, e.target) > -1) {
    app.handlers.nextstep(e);
  }

  if (Array.prototype.indexOf.call(app.nodes.previousstep, e.target) > -1) {
    app.handlers.previousstep(e);
  }

  if (Array.prototype.indexOf.call(app.nodes.datatoggles, e.target) > -1) {
    app.handlers.show(e.target.getAttribute("data-toggles"), e);
  }
}, false);

app.nodes.wms.load.addEventListener("click", app.handlers.wms.load, false);
app.nodes.wms.add.addEventListener("click", app.handlers.wms.add, false);

app.nodes.wmts.load.addEventListener("click", app.handlers.wmts.load, false);
app.nodes.wmts.add.addEventListener("click", app.handlers.wmts.add, false);

function addLayer(layerOrPromise, skipFit?) {
  return Promise.resolve(layerOrPromise).then(function(layer) {
    if (layer instanceof FeatureLayer) {
      // Add simple balloon
      if (!layer.balloonContentProvider) {
        layer.balloonContentProvider = SimpleBalloonContentProvider;
      }
    }
    if (!skipFit) {
      getFitBounds(layer).then(fitBounds => {
        if (fitBounds) {
          map.mapNavigator.fit({
            bounds: fitBounds,
            animate: true
          });
        }
      });
    }
    // Actually add the layer to the map
    if (layer.type === LayerType.BASE) {
      var referenceLayer = findBaseLayer(map);
      if (referenceLayer !== null) {
        map.layerTree.addChild(layer, "above", referenceLayer);
      } else {
        map.layerTree.addChild(layer, "bottom");
      }
    } else {
      map.layerTree.addChild(layer, "top");
    }

    layer.visible = true;
    return layer;
  }, function(error) {
    toast.error(null, "Nepodařilo se přidat vrstvu: " + error.message, error);
  });
}

function flattenWmsLayerHierarchy(layers) {
  return layers.reduce(function(accumulated, value) {
    accumulated.push(value);
    if (value.children) {
      accumulated = accumulated.concat(flattenWmsLayerHierarchy(value.children));
    }
    return accumulated;
  }, []);
}

function renderWMSLayersPanel() {
  var layersPanel = app.nodes.wms.layersPanel;
  layersPanel.innerHTML = "";

  app.state.wms.layers.forEach(function(layer) {
    var layerElement = document.createElement("div");
    layerElement.className = "panel-row layer-row";

    layerElement.innerHTML = "<div class='checkbox' title='" + layer.title + "'>" +
                             "<label class='label'>" +
                             "<input type='checkbox' />" + layer.title +
                             "</label>" +
                             "</div>" +
                             "<select class='style form-control'>" +
                             "<option value=''>Vyberte styl</option>" +
                             layer.styles.map(function(s) {
                               var styleName = s.title || s.identifier;
                               return "<option value='" + s.name + "'>" + styleName + "</option>";
                             }).join("") +
                             "</select>";

    layerElement.querySelector(".label input").addEventListener("change", function(event) {
      layer.isSelected = event.target.checked;
    });

    layerElement.querySelector(".style").addEventListener("change", function(event) {
      layer.selectedStyle = event.target.value;
    });

    layersPanel.appendChild(layerElement);
  });

  resetMapSize();
}

function renderWMTSLayersPanel() {
  var layersPanel = app.nodes.wmts.layersPanel;
  layersPanel.innerHTML =
    "<label>Layers</label><select class='wmts-layer form-control'>" +
    app.state.wmts.layers.map(function(l) {
      return "<option value='" + l.identifier + "'>" + l.title + "</option>";
    }).join("") +
    "</select>";

  layersPanel.querySelector(".wmts-layer").addEventListener("change", function(event) {
    app.state.wmts.selectedLayer = event.target.value;
    renderLayerOptions();
  });

  app.state.wmts.selectedLayer = app.state.wmts.layers[0].layer.identifier;
  renderLayerOptions();

  resetMapSize();
}

function renderLayerOptions() {
  var style = app.nodes.wmts.style;
  var selectedLayer = app.state.wmts.layers.filter(function(l) {
    return l.identifier === app.state.wmts.selectedLayer;
  })[0].layer;
  var styles = selectedLayer.styles;
  app.state.wmts.style = styles[0].identifier;

  style.innerHTML =
    "<label>Styl</label><select class='wmts-style form-control'>" +
    styles.map(function(s) {
      var styleName = s.title || s.identifier;
      return "<option value='" + s.identifier + "'>" + styleName + "</option>";
    }).join("") +
    "</select>";

  style.querySelector(".wmts-style").addEventListener("change", function(event) {
    app.state.wmts.style = event.target.value;
  });
}

function findClosestAncestor(elem, selector) {
  if (elem.closest) {
    return elem.closest(selector);
  }
  var matches = (document || this.ownerDocument).querySelectorAll(selector);
  var i;
  do {
    i = matches.length;
    while (--i >= 0 && matches.item(i) !== elem) {
      // Do nothing
    }
  } while ((i < 0) && (elem = elem.parentElement));
  return elem;
}

function selectorMatches(el, selector) {
  var p = Element.prototype;
  var f = p.matches || p.webkitMatchesSelector || p.mozMatchesSelector || p.msMatchesSelector || function(s) {
    return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
  };
  try {
    return f.call(el, selector);
  } catch (e) {
    return false;
  }
}

function getNextSibling(elem, selector) {

  // Get the next sibling element
  var sibling = elem.nextSibling;
  var match;

  // If there's no selector, return the first sibling
  if (!selector) {
    return sibling;
  }

  // If the sibling matches our selector, use it
  // If not, jump to the next sibling and continue the loop
  while (sibling) {
    if (selectorMatches(sibling, selector)) {
      return sibling;
    }
    sibling = sibling.nextSibling;
  }
  return null;
}

function getPreviousSibling(elem, selector) {

  // Get the next sibling element
  var sibling = elem.previousSibling;

  // If there's no selector, return the first sibling
  if (!selector) {
    return sibling;
  }

  // If the sibling matches our selector, use it
  // If not, jump to the next sibling and continue the loop
  while (sibling) {
    if (selectorMatches(sibling, selector)) {
      return sibling;
    }
    sibling = sibling.previousSibling;
  }
  return null;
}

function clearOnLoad(node) {
  var clearonload = node.getAttribute("data-clearonload");
  if (clearonload) {
    clearonload = clearonload.split(",");
    for (var i = 0; i < clearonload.length; i++) {
      document.getElementById(clearonload[i]).value = "";
    }
  }
}

function getNextStep(stepNode, path) {
  var nextStepNode = getNextSibling(stepNode, ".step");
  if (nextStepNode) {
    clearOnLoad(nextStepNode);
    stepNode.classList.add("hidden");
    nextStepNode.classList.remove("hidden");
    var paths = selectDescendantBySelector(nextStepNode, ".data-path");
    var found = false;
    Object.keys(paths).forEach(function(key) {
      var currentPath = paths[key];
      if (currentPath.classList.contains(path)) {
        currentPath.classList.remove("hidden");
        found = true;
      } else {
        currentPath.classList.add("hidden");
      }
    });
    if (!found) {
      getNextStep(nextStepNode, path);
    }
  } else {
    app.handlers.removeoverlay();
  }
}

function selectDescendantBySelector(ancestor, selector) {
  var found;
  try {
    found = ancestor.querySelectorAll(":scope " + selector);
  } catch (e) {
    // IE11 throws a syntax error for selectors that include :scope, so use this hack instead
    ancestor.classList.add("selectDescendantBySelectorScopeHack");
    found = document.querySelectorAll(".selectDescendantBySelectorScopeHack " + selector);
    ancestor.classList.remove("selectDescendantBySelectorScopeHack");
  }
  return found;
}

function BaseLayerFinder() {
  this.baseLayer = null;
}

BaseLayerFinder.prototype.visitLayer = function(layer) {
  if (layer.type === LayerType.BASE) {
    this.baseLayer = layer;
    return LayerTreeVisitor.ReturnValue.ABORT;
  }
  return LayerTreeVisitor.ReturnValue.CONTINUE;
};

BaseLayerFinder.prototype.visitLayerGroup = function(layerGroup) {
  layerGroup.visitChildren(this, LayerTreeNode.VisitOrder.TOP_DOWN);
  return (this.baseLayer !== null) ? LayerTreeVisitor.ReturnValue.ABORT : LayerTreeVisitor.ReturnValue.CONTINUE;
};

function findBaseLayer(map) {
  var baseLayerfinder = new BaseLayerFinder();
  map.layerTree.accept(baseLayerfinder);
  return baseLayerfinder.baseLayer;
}

// #####################
// #### Share panel ####
// #####################

const sharePanel = document.getElementById("sharepanel");
const sharePanelOverlay = document.getElementById("sp-overlay");
const shareURL = document.getElementById("sp-input-url");
const copyURL = document.getElementById("sp-copy-url");

// Set button Kopírovat initial state
if (copyURL)
  copyURL.classList.add('inactiveLink');
var initialValue = 'Načítám...'

if (sharePanel) {
  sharePanel.addEventListener("click", function () {

    // Open share panel with options
    if (sharePanelOverlay) {
      sharePanelOverlay.classList.add("visible");
    }

    // Display URL
    if (shareURL) {
      var shortenedUrl = initialValue
      shareURL.value = shortenedUrl;
      getShortUrl(window.location.href).then(result => {
        shortenedUrl = result;
        shareURL.value = shortenedUrl;
        // Activate button Kopírovat
        if(copyURL)
          copyURL.classList.remove('inactiveLink');
      });
    }
  }, false);

  // Copy to clipboard
  if (copyURL) {
    copyURL.addEventListener("click", function () {
  
      ShareView.copyToClipboard("sp-input-url");
    }, false);
  }

  // Close panel
  const closeIcon = document.getElementById("close-sharepanelui");

  if (closeIcon) {
    closeIcon.addEventListener("click", function () {
      if (sharePanelOverlay) {
        sharePanelOverlay.classList.remove("visible");
      }
    }, false);
  }
}